module.exports = __webpack_public_path__ + "static/img/AW.defa42fd.svg";